type EnvMap = Record<string, string | undefined>;

const resolveEnv = (): EnvMap => {
  const globalEnv = (globalThis as { __YOLO_ADMIN_ENV__?: EnvMap }).__YOLO_ADMIN_ENV__;
  const runtimeEnv = (globalThis as { __ENV__?: EnvMap }).__ENV__;
  const injected = (globalThis as { importMetaEnv?: EnvMap }).importMetaEnv;
  const procEnv = typeof process !== 'undefined' ? (process.env as EnvMap | undefined) : undefined;
  return {
    ...(globalEnv ?? {}),
    ...(runtimeEnv ?? {}),
    ...(injected ?? {}),
    ...(procEnv ?? {}),
  } as EnvMap;
};

const env = resolveEnv();

export const SITE_CONFIG = {
  api: {
    base: env['VITE_YOLO_API_URL'] ?? '/api/v1',
  },
  pricing: {
    customerId: env['VITE_YOLO_CUSTOMER_ID'],
  },
  auth: {
    idpBase: env['VITE_IDP_BASE_URL'],
    audience: env['VITE_IDP_AUDIENCE'] ?? 'yolo-admin',
  },
};
